export const jobPosts = {
  alerts: {
    errorApplied: 'Une erreur s’est produite lors de l’envoi de votre réponse. Veuillez réessayer plus tard.',
    successCancelled: 'Votre mission a été annulée et n’est plus affichée.',
    successCreated: 'Votre mission a été créée.',
    successFilled: 'Votre mission a été pourvue et n’est plus affichée.',
    successUpdated: 'Votre mission a été modifiée.',
  },
  apply: {
    actions: {
      submit: 'Envoyer',
    },
    motivation: {
      explanation: 'Rédigez ici une réponse personnelle pour votre client.',
      title: 'Votre motivation',
    },
    profile: {
      contactDetails: 'Vos coordonnées',
      explanation:
        'Nous partageons les données ci-dessous avec votre client. Vous pouvez décocher vous-même les informations que vous préférez ne pas partager.',
      fields: {
        address: 'Adresse',
        email: 'Adresse e-mail',
        links: 'Liens',
        phone: 'Numéro de téléphone',
      },
      introductionText: 'Introduction',
      title: 'Votre profil',
    },
    successDialog: {
      buttonText: 'Compris !',
      description:
        'Votre réponse a été envoyée au client. Il ou elle en reçoit un e-mail et vous contactera ensuite (espérons-le). Un peu de patience, donc.',
      title: 'Réponse envoyée',
    },
    title: 'Contacter',
  },
  breadcrumb: {
    bookmarked: 'Missions sauvegardées',
    create: 'Créer une mission',
    overview: 'Missions',
    own: 'Mes missions',
  },
  card: {
    postedByCS: 'Sélectionnée par Creative Shelter',
    postedByFreelancer: 'Publiée par un freelance',
  },
  contextMenu: {
    actions: {
      cancelled: 'Annuler',
      edit: 'Modifier',
      filled: 'Pourvue',
    },
    dialogs: {
      cancelled: {
        actions: {
          cancel: 'Non, revenir en arrière',
          confirm: 'Oui, j’en suis sûr·e !',
        },
        description: 'Votre mission reçoit le statut « annulée » et n’est plus affichée. Cette modification est irréversible.',
        title: 'Êtes-vous sûr·e ?',
      },
      filled: {
        actions: {
          cancel: 'Non, revenir en arrière',
          confirm: 'Oui, j’en suis sûr·e !',
        },
        description: 'Votre mission reçoit le statut « pourvue » et n’est plus affichée. Cette modification est irréversible.',
        title: 'Êtes-vous sûr·e ?',
      },
    },
  },
  createEdit: {
    actions: {
      create: 'Créer la mission',
    },
    blocker: 'Voulez-vous vraiment quitter cette page ? Votre mission n’a pas été enregistrée.',
    sections: {
      basic: {
        title: 'Informations de base',
      },
      details: {
        title: 'Détails de la mission',
      },
      planning: {
        title: 'Planning',
      },
    },
    title: {
      create: 'Nouvelle mission',
      edit: 'Modifier la mission',
    },
  },
  details: {
    actions: {
      alreadyApplied: 'Déjà contacté',
      apply: 'Contacter le client',
    },
    info: {
      alreadyApplied: {
        description: 'Vous avez contacté le client, il ne reste plus qu’à attendre sa réponse.',
        title: 'Client contacté',
      },
      userHasCreated: {
        description: 'Vous ne pouvez pas y répondre vous-même, mais vous pouvez la modifier si vous le souhaitez.',
        title: 'Vous avez publié cette mission vous-même',
      },
    },
  },
  fields: {
    activities: {
      label: 'Type de mission',
      placeholder: 'Sélectionner',
    },
    closesAt: {
      label: 'Répondre avant le',
    },
    createdAt: {
      label: 'Créée le',
    },
    description: {
      label: 'Description',
    },
    endsAt: {
      label: 'Date de fin',
    },
    experienceLevel: {
      label: 'Expérience',
      options: {
        Junior: 'Junior',
        Medior: 'Intermédiaire',
        Senior: 'Senior',
      },
      placeholder: 'Sélectionner',
    },
    isPriceToBeDiscussed: {
      label: 'À discuter',
    },
    locationType: {
      label: 'Lieu de travail',
      options: {
        Hybrid: 'Hybride',
        Onsite: 'Sur place',
        Remote: 'À distance',
      },
      placeholder: 'Sélectionner',
    },
    price: {
      label: 'Budget',
      placeholder: 'Budget',
    },
    priceUnit: {
      label: 'Unité',
      options: {
        Daily: 'Jour',
        Fixed: 'Forfait',
        HalfDaily: 'Demi-journée',
        Hourly: 'Heure',
        PricePerWord: 'Mot',
      },
      placeholder: 'Unité de prix',
    },
    region: {
      label: 'Lieu de la mission',
      placeholder: 'Sélectionner',
    },
    startsAt: {
      label: 'Date de début',
    },
    status: {
      options: {
        Cancelled: 'Annulée',
        Filled: 'Pourvue',
        Open: 'Ouverte',
      },
    },
    title: {
      label: 'Titre',
      placeholder: 'Titre',
    },
  },
  overview: {
    actions: {
      create: 'Créer une mission',
    },
    bookmarked: {
      empty: 'Vous n’avez pas encore sauvegardé de missions.',
    },
    description: 'Trouvez ici des missions de qualité proposées par d’autres freelances et des clients externes.',
    error: {
      title: 'Erreur lors du chargement des missions.',
    },
    filters: {
      activities: 'Activités',
      locationType: 'Lieu de travail',
      regions: 'Régions',
    },
    loading: 'Chargement des données…',
    own: {
      empty: 'Vous n’avez pas encore créé de missions.',
    },
    resetFilters: '(effacer les filtres)',
    resultCount_one: '{{count}} résultat',
    resultCount_other: '{{count}} résultats',
    resultCount_zero: 'Aucun résultat ne correspond à vos filtres',
    title: 'Missions',
  },
  specifications: {
    closesAt: 'Répondre avant le',
    experienceLevel: 'Expérience',
    location: 'Lieu',
    locationType: 'Lieu de travail',
    period: 'Période',
    price: 'Budget',
  },
  tabs: {
    all: 'Toutes les missions',
    bookmarked: 'Missions sauvegardées',
    own: 'Mes missions',
  },
};
